import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import GenericDataTable from "../Shared/DataTable/GenericDataTable.js";

const CountryRegistrationsTotals = ({ globalContext }) => {


    function formatDate(isoString) {
        return isoString.split('T')[0];
    }

    let legalManufacturerFilter = window.legalManufacturerId ? { legalManufacturerId: window.legalManufacturerId } : {};

    return <>

        <GenericDataTable
            columns={[
                
                {
                    key: "CountryName",
                    label: "Country",
                    sortable: true,
                    size: "300px",

                    render: ({ row, value }) => (
                        <div
                            style={{
                                padding: "12px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            <a
                                href={`/your-medboard/country-registrations/registrations/?filter[CountryId]=${row.CountryId}`}
                                style={{
                                    color: "#203864",
                                    textDecoration: "none", 
                                    fontWeight: "600"
                                }}
                            >
                                <img style={{width: "auto", height: "25px", marginRight: "10px"}} src={`${row.FlagLink}`} /> {value}
                            </a>
                        </div>
                    ),
                },

                {
                    key: "LastUpdated",
                    label: "Last Updated",
                    sortable: true,
                    size: "200px",

                    render: ({ row, value }) => (
                        <div
                            style={{
                                padding: "12px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {formatDate(value)}
                        </div>
                    ),
                },

                {
                    key: "Total",
                    label: "Total Registrations",
                    sortable: true,
                    size: "200px",

                    render: ({ row, value }) => (
                        <div
                            style={{
                                padding: "12px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {value}
                        </div>
                    ),
                },
            ]}
            fetchUrl="/umbraco/api/RIMSRegistrations/RegistrationsByCountry/"
            enableDelete={false}
            enableExport={false}
            //deleteUrl="/umbraco/api/RIMSProducts/BulkProducts/"
            //exportUrl="/umbraco/api/RIMSProducts/ProductsExport/"
            queryParams={legalManufacturerFilter}
            //exportFileName={`country-registrations-totals-export.xlsx`}
            rowTitleKey="ProductName"
            searchPlaceholder="Search"
            LoadingComponent={LoadingSpinnerImage}
            showTotalCount={true}
            totalCountUrl="/umbraco/api/RIMSRegistrations/RegistrationsByCountryCount/"
        />

    </>


}

export default CountryRegistrationsTotals;